<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="edit" clip-path="url(#clip0_0_982)">
<g id="Vector">
</g>
<path id="Vector_2" d="M2.5 14.375V17.5H5.625L14.8417 8.28333L11.7167 5.15833L2.5 14.375ZM17.2583 5.86667C17.5833 5.54167 17.5833 5.01667 17.2583 4.69167L15.3083 2.74167C14.9833 2.41667 14.4583 2.41667 14.1333 2.74167L12.6083 4.26667L15.7333 7.39167L17.2583 5.86667V5.86667Z" fill="#323232"/>
</g>
<defs>
<clipPath id="clip0_0_982">
<rect width="20" height="20" fill="white"/>
</clipPath>
</defs>
</svg>
